import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import Fish from '../game/Fish';
import JellyFish from '../game/JellyFish';
import Kelp from '../game/Kelp';
import gameData from '../gameData';
import UIAssetKeys from '../UIAssetKeys';
import LevelBase from './LevelBase';

export default class Level4 extends LevelBase {
  static get KEY() { return 'Level4'; }

  constructor() {
    super({ key: Level4.KEY });
  }

  init() {
    gameData.config.level = 4;

    super.init();

    this.coral1 = null;
    this.coral2 = null;
    this.anenomes = null;
    this.seaweed1 = null;
    this.seaweed2 = null;
    this.seaweed3 = null;
    this.seaweed4 = null;

    /** @type {JellyFish[]} */
    this.doodads = [];

    /** @type {Phaser.Tweens.Tween[]} */
    this.doodTweens = [];

    this.shaderCont = null;
    this.shader = null;
    this.fishies = null;
    this.treasure = null;
  }

  createNextScene () {
    super.createNextScene();

    const bg = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._1_Welcome_and_Level_Screen_Bkgd_1, this.nextLvlCont).setOrigin(0);

    const wavesB = ABCyaPhaser.Images.addImage(0, this.scale.height, UIAssetKeys._1_Welcome_and_Level_Screen_Wave_Bkgd, this.nextLvlCont).setOrigin(0, 1);
    const wavesF = ABCyaPhaser.Images.addImage(0, this.scale.height, UIAssetKeys._1_Welcome_and_Level_Screen_Wave_Midgd, this.nextLvlCont).setOrigin(0,1);
    const randWave1Wave = ABCyaPhaser.Images.addImage(150, 625, UIAssetKeys._1_Welcome_and_Level_Screen_Wave_Frgd1, this.nextLvlCont).setOrigin(0.5);
    const randWave2Wave = ABCyaPhaser.Images.addImage(600, 650, UIAssetKeys._1_Welcome_and_Level_Screen_Wave_Frgd1, this).setOrigin(0.5);
    const randWave3Wave = ABCyaPhaser.Images.addImage(920, 725, UIAssetKeys._1_Welcome_and_Level_Screen_Wave_Frgd2, this).setOrigin(0.5);

    const octoWave = ABCyaPhaser.Images.addImage(375, 729,UIAssetKeys._1_Welcome_and_Level_Screen_OctoWave, this.nextLvlCont).setOrigin(0.5);
  }

  createBackground () {
    super.createBackground();

    this.fishies = new Fish(this);
    this.add.existing(this.fishies);

    this.coral1 = ABCyaPhaser.Images.addImage(-10, this.scale.height + 20, UIAssetKeys._7_Level_4_Lvl4_CoralLeft, this).setOrigin(0, 1);
    this.coral2 = ABCyaPhaser.Images.addImage(this.scale.width + 10, this.scale.height + 20, UIAssetKeys._7_Level_4_Lvl4_CoralRight, this).setOrigin(1);

    this.createJelly();
  }

  // don't create lights for this one
  createLights () { }

  createJelly () {
    const jelly1 = new JellyFish(this, 1, 1);
    const jelly2 = new JellyFish(this, 1, 2);
    const jelly3 = new JellyFish(this, 2, 3);
    const jelly4 = new JellyFish(this, 2, 5);

    this.add.existing(jelly1);
    this.add.existing(jelly2);
    this.add.existing(jelly3);
    this.add.existing(jelly4);

    this.doodads = [jelly1, jelly2, jelly3, jelly4];
  }

  createShader () {
    this.shader = this.add.rectangle(0,0,this.scale.width, this.scale.height, 0x000000).setOrigin(0)
      .setInteractive()
      .setAlpha(0);
    this.shaderCont.add(this.shader);

    ABCyaPhaser.Tweens.addTween(this.shader, 500, { alpha: 0.5 }, Phaser.Math.Easing.Linear);
  }

  hideShader () {
    if (this.shader) {
      ABCyaPhaser.Tweens.addTween(this.shader, 500, { alpha: 0 }, Phaser.Math.Easing.Linear, () => {
        this.shader.destroy();
        this.shader = null;
      });

      this.sub.tweenOutSpeech();
    }
  }

  fullClean () {
    for (let i = 0; i < this.doodads.length; i++) {
      this.doodads[i].cleanUp();
      this.doodads[i].destroy();
    }
    this.doodads = [];

    this.coral1.destroy();
    this.coral2.destroy();

    this.fishies.cleanUp();
    this.fishies.destroy();

    super.fullClean();
  }

  cleanUp () {
    for (let i = 0; i < this.doodads.length; i++) {
      this.doodads[i].cleanUp();
      this.doodads[i].destroy();
    }
    this.doodads = [];

    this.coral1.destroy();
    this.coral2.destroy();

    this.fishies.cleanUp();
    this.fishies.destroy();

    super.cleanUp();
  }
}